import React from 'react';
import BlueDotsBackground from '../../BlueDotsBackground';

export default function PriceReallocation() {
  return (
    <>
      <BlueDotsBackground />
      <section
        id="hero"
        className="relative text-center text-white overflow-hidden font-sans"
      >
        <div className="relative z-10 px-6 min-h-screen flex flex-col justify-center">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-semibold tracking-tight leading-tight mb-8">
              Struggling to stay ahead of GP estimation and reallocation under
              tight deadlines?
            </h1>
            <p className="text-lg md:text-2xl text-gray-300 font-light mb-12">
              OpenPharma automates the most complex product and temporal
              reallocations required for BP, ASP, and AMP, along with robust
              estimation logic for BPI using actual and contract-based data.
              Once reallocated and estimated, results are seamlessly integrated
              into Model N to support accurate and timely GP calculations.
            </p>
            <div className="max-w-xl w-full mx-auto mb-20"></div>
          </div>
        </div>
      </section>
    </>
  );
}
